import { render, staticRenderFns } from "./PoiSubLake.vue?vue&type=template&id=b3d8fad0"
import script from "./PoiSubLake.js?vue&type=script&lang=js&external"
export * from "./PoiSubLake.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports